<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="cabinas"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Reincidencia</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-col cols="2">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-menu
              v-if="true"
              v-model="menuFechas"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mx-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Opciones</v-btn
                >
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      v-model="placaBusqueda"
                      label="Placa"
                      v-if="verNuevo == 0"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-select
                      class="mt-n5"
                      v-model="tipoServicioBusqueda"
                      label="Tipo Servicio"
                      :items="list_tipoServicio"
                      v-if="verNuevo == 0"
                      clearable
                    ></v-select>
                  </v-list-item>
                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Desde"
                      v-model="fechaInicio"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Hasta"
                      v-model="fechaFin"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" dark @click="listarReincidendias()"
                      >Filtrar</v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn
              color="green"
              @click="descargarReincidencia()"
              class="mt-0"
              dark
              v-if="verNuevo == 0"
              >Descargar</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="numeroAsistenciaDialog"
                    label="NUMERO DE ASISTENCIA"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="operadorDialog"
                    label="OPERADOR"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="fechaHoraActualDialog"
                    label="FECHA APERTURA"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <v-text-field
                    v-model="comDireccionSiniestroDialog"
                    label="DIRECCION"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="tipoServicioDialog"
                    label="TIPO SERVICIO"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="proveedorDialog"
                    label="PROVEEDOR ASIGNADO"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="atiendeDialog"
                    label="ATIENDE"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="fechaHoraAsignacionDialog"
                    label="FECHA ASIGNACION"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="seguimiento1"
                    label="SEGUIMIENTO"
                    :disabled="disabled1"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 2">
                  <v-text-field
                    v-model="seguimiento2"
                    label="SEGUIMIENTO"
                    :disabled="disabled2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 3">
                  <v-text-field
                    v-model="seguimiento3"
                    label="SEGUIMIENTO"
                    :disabled="disabled3"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 4">
                  <v-text-field
                    v-model="seguimiento4"
                    label="SEGUIMIENTO"
                    :disabled="disabled4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 5">
                  <v-text-field
                    v-model="seguimiento5"
                    label="SEGUIMIENTO"
                    :disabled="disabled5"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 6">
                  <v-text-field
                    v-model="seguimiento6"
                    label="SEGUIMIENTO"
                    :disabled="disabled6"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 7">
                  <v-text-field
                    v-model="seguimiento7"
                    label="SEGUIMIENTO"
                    :disabled="disabled7"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 8">
                  <v-text-field
                    v-model="seguimiento8"
                    label="SEGUIMIENTO"
                    :disabled="disabled8"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 9">
                  <v-text-field
                    v-model="seguimiento9"
                    label="SEGUIMIENTO"
                    :disabled="disabled9"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="contador >= 10">
                  <v-text-field
                    v-model="seguimiento10"
                    label="SEGUIMIENTO"
                    :disabled="disabled10"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="cancel" @click="close">CANCELAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12 sm4 md4 lg6 x14 v-if="errorPlaca">
        <div class="red--text" v-text="errorPlaca"></div>
      </v-flex>
      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="placa" label="Placa"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="poliza" label="Poliza"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="marca" label="Marca"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="modelo" label="Modelo"></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2>
            <v-text-field
              type="number"
              v-model="año"
              label="Año"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2>
            <v-text-field v-model="uso" label="Uso"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="titularPoliza"
              label="Ttular Poliza"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg4 x14>
            <v-text-field v-model="cartera" label="Cartera"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="fechaHoraOcurrencia"
              label="Fecha Ocurrencia"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="numeroTelefono"
              label="Numero Telefono"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="color" label="Color"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg5 x14>
            <v-text-field
              v-model="nombreConductor"
              label="Nombre conductor"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3 x14>
            <v-text-field v-model="pais" label="Pais"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="depaSiniestro"
              label="Departamento Siniestro"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="muniSiniestro" label="Municipio Siniestro">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="comDireccionSiniestro"
              label="Complemento Direccion Siniestro"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="causa" label="Causa"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="tipoServicio" label="Tipo De Servicio">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="proveedor" label="Proveedor"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="atiende" label="Atiende"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="fechaHoraAsignacion"
              label="Fecha Asignacion"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="depaOrigen" label="Departamento Origen">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="muniOrigen" label="Municipio Origen">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="comDireccionOrigen"
              label="Complemento Direccion Origen"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="depaDestino" label="Departamento Destino">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="muniDestino" label="Municipio Destino">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="comDireccionDestino"
              label="Complemento Direccion Destino"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="fechaHoraContacto"
              label="Fecha Contacto"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="costoServicio"
              label="Costo Servicio"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md3 lg3>
            <v-text-field
              v-model="termino"
              label="Termino"
              step="1"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="placaContraparte"
              label="Placa Contraparte"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="obsAdicionales"
              label="Observaciones Adicionales"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="tipoAsistencia" label="Tipo Asistencia">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="estatusAsistencia"
              label="Estatus Asistencia"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field v-model="operador" label="Operador"> </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field
              v-model="numeroSiniestroQualitas"
              label="Numero Siniestro Qualitas"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field
              v-model="numeroSpoolerQualitas"
              label="Numero Spooler Qualitas"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field
              v-model="localForaneo"
              label="Local/Foraneo"
            ></v-text-field>
          </v-flex>
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="partePolicial"
                label="Hay Parte Policial?"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="seMovioDelLugar"
                label="Se Movio Del lugar"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="zonaPeligrosa"
                label="zona Peligrosa"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="reporteTardio"
                label="Reporte Tardio"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="roboRecuperado"
                label="Robo Recuperado"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="recupero"
                label="Recupero Tercero"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-col cols="12" sm="2" md="2" v-if="recupero">
            <v-text-field
              v-model="cantRecupero"
              type="number"
              label="Recupero Tercero"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-checkbox
              v-model="estadoEbriedad"
              label="Estado de ebriedad"
            ></v-checkbox>
          </v-col>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="fechaHoraCierreAsistencia"
              label="Fecha Cierre Asistencia"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-spacer></v-spacer>
            <v-btn @click="ocultarNuevo()" color="cancel">Cancelar</v-btn>
            <v-btn @click="verBitacora()" color="warning" class="mx-5"
              >Ver bitacora</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-snackbar v-model="snackValidacion" color="cyan darken-2" right top
      >No deben de estar vacios los campos de Placa y Tipo de
      servicio.</v-snackbar
    >
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      dialog: false,
      cabinas: [],
      datosSeguimiento: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Nmero Asistencia",
          value: "numeroAsistencia",
        },
        { text: "Cartera", value: "cartera" },
        { text: "Fecha Actual", value: "fechaHoraActual" },
        {
          text: "Fecha Ocurrencia",
          value: "fechaHoraOcurrencia",
        },
        { text: "Telefono", value: "numeroTelefono" },
        { text: "Placa", value: "placa" },
        { text: "Poliza", value: "poliza" },
        { text: "Marca", value: "marca" },
        { text: "Modelo", value: "modelo" },
        { text: "Año", value: "año" },
        { text: "Titular Poliza", value: "titularPoliza" },
        {
          text: "Estado",
          align: "left",
          value: "estatusAsistencia",
        },
      ],
      search: "",
      id: "",
      idBase: "",
      cartera: "",
      fechaHoraOcurrencia: "",
      numeroAsistencia: "",
      numeroTelefono: "",
      placa: "",
      placaBusqueda: "",
      tipoServicioBusqueda: "",
      list_tipoServicio: ["ADICIONAL", "EMERGENCIA", "CONEXION"],
      poliza: "",
      marca: "",
      modelo: "",
      año: 0,
      uso: "",
      titularPoliza: "",
      estatusBase: "",
      color: "",
      nombreConductor: "",
      pais: "",
      depaSiniestro: "",
      muniSiniestro: "",
      comDireccionSiniestro: "",
      causa: "",
      tipoServicio: "",
      proveedor: "",
      atiende: "",
      fechaHoraAsignacion: "",
      depaOrigen: "",
      muniOrigen: "",
      comDireccionOrigen: "",
      depaDestino: "",
      muniDestino: "",
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: 0,
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      obsAdicionales: "",
      tipoAsistencia: "",
      numeroSiniestroQualitas: "",
      numeroSpoolerQualitas: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      operador: "",
      estatusAsistencia: "",
      verNuevo: 0,
      fechaHoraActual: "",
      seguimiento1: "",
      seguimiento2: "",
      seguimiento3: "",
      seguimiento4: "",
      seguimiento5: "",
      seguimiento6: "",
      seguimiento7: "",
      seguimiento8: "",
      seguimiento9: "",
      seguimiento10: "",
      errorPlaca: null,
      disabled1: false,
      disabled2: false,
      disabled3: false,
      disabled4: false,
      disabled5: false,
      disabled6: false,
      disabled7: false,
      disabled8: false,
      disabled9: false,
      disabled10: false,
      contador: 0,
      cadena: "",
      separado: [],
      numeroAsistenciaDialog: "",
      operadorDialog: "",
      fechaHoraActual: "",
      comDireccionSiniestroDialog: "",
      tipoServicioDialog: "",
      proveedorDialog: "",
      atiendeDialog: "",
      fechaHoraActualDialog: "",
      fechaHoraAsignacionDialog: "",
      fechaHoraContactoDialog: "",
      fechaHoraCierreAsistenciaDialog: "",
      obsAdicionalesDialog: "",
      recupero: false,
      termino: "",
      estadoEbriedad: false,
      cantRecupero: "",
      overlay: false,
      snackValidacion: false,
      menuFechas: false,
      fechaInicio: "",
      fechaFin: "",
    };
  },
  computed: {
    formTitle() {
      return "Seguimiento";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    ocultarNuevo() {
      this.verNuevo = 0;
    },
    close() {
      this.dialog = false;
    },
    listarReincidendias() {
      let me = this;
      me.limpiar();
      this.cabinas = [];
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (
        me.fechaInicio != null &&
        me.fechaFin != null &&
        me.placa != null &&
        me.tipoServicioBusqueda != null
      ) {
        axios
          .get(
            "api/Cabinas/MostrarReincidencia/" +
              this.fechaInicio +
              "/" +
              this.fechaFin +
              "/" +
              this.placaBusqueda +
              "/" +
              this.tipoServicioBusqueda,
            configuracion
          )
          .then(function (response) {
            me.cabinas = response.data;
            if (response.status == 200) {
              me.overlay = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            me.errorPlaca = "No se encuentra registrada la placa.";
          });
      } else {
        console.log("fecha inicio", me.fechaInicio);
        console.log("fecha fin", me.fechaFin);
        console.log("fecha placa", me.placaBusqueda);
        console.log("fecha tipo", me.tipoServicioBusqueda);
        me.$alertify.success("DEBE DE COMPLETAR LOS CAMPOS");
      }
    },
    verDetalles(item) {
      this.limpiar();
      this.id = item.idCabina;
      this.idBase = item.idBase;
      this.idUsuario = item.idUsuario;
      this.fechaHoraActualDialog = item.fechaHoraActual;
      this.numeroAsistencia = item.numeroAsistencia;
      this.numeroAsistenciaDialog = item.numeroAsistencia;
      this.cartera = item.cartera;
      this.fechaHoraOcurrencia = item.fechaHoraOcurrencia;
      this.numeroTelefono = item.numeroTelefono;
      this.placa = item.placa;
      this.poliza = item.poliza;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.año = item.año;
      this.uso = item.uso;
      this.titularPoliza = item.titularPoliza;
      this.color = item.color;
      this.nombreConductor = item.nombreConductor;
      this.pais = item.pais;
      this.depaSiniestro = item.depaSiniestro;
      this.muniSiniestro = item.muniSiniestro;
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.comDireccionSiniestroDialog = item.comDireccionSiniestro;
      this.causa = item.causa;
      this.tipoServicio = item.tipoServicio;
      this.tipoServicioDialog = item.tipoServicio;
      this.proveedor = item.proveedor;
      this.proveedorDialog = item.proveedor;
      this.atiende = item.atiende;
      this.atiendeDialog = item.atiende;
      this.fechaHoraAsignacion = item.fechaHoraAsignacion;
      this.fechaHoraAsignacionDialog = item.fechaHoraAsignacion;
      this.depaOrigen = item.depaOrigen;
      this.muniOrigen = item.muniOrigen;
      this.comDireccionOrigen = item.comDireccionOrigen;
      this.depaDestino = item.depaDestino;
      this.muniDestino = item.muniDestino;
      this.comDireccionDestino = item.comDireccionDestino;
      this.fechaHoraContacto = item.fechaHoraContacto;
      this.costoServicio = item.costoServicio;
      this.fechaHoraCierreAsistencia = item.fechaHoraCierreAsistencia;
      this.placaContraparte = item.placaContraparte;
      this.partePolicial = item.partePolicial;
      this.obsAdicionales = item.obsAdicionales;
      this.tipoAsistencia = item.tipoAsistencia;
      this.operador = item.operador;
      this.operadorDialog = item.operador;
      this.numeroSiniestroQualitas = item.numeroSiniestroQualitas;
      this.numeroSpoolerQualitas = item.numeroSpoolerQualitas;
      this.seMovioDelLugar = item.seMovioDelLugar;
      this.zonaPeligrosa = item.zonaPeligrosa;
      this.reporteTardio = item.reporteTardio;
      this.estatusAsistencia = item.estatusAsistencia;
      this.roboRecuperado = item.roboRecuperado;
      this.localForaneo = item.localForaneo;
      this.cantRecupero = item.cantRecupero;
      this.termino = item.termino;
      this.estadoEbriedad = item.estadoEbriedad;
      this.verNuevo = 1;
      //verificar si en el campo cantRecupero hay digito
      this.verificarRecupero();
    },
    limpiar() {
      this.id = "";
      this.idBase = "";
      this.idUsuario = "";
      this.cartera = "";
      this.fechaHoraOcurrencia = "";
      this.numeroTelefono = "";
      this.placa = "";
      this.poliza = "";
      this.modelo = "";
      this.marca = "";
      this.año = 0;
      this.uso = "";
      this.titularPoliza = "";
      (this.condicion = ""), (this.color = "");
      this.nombreConductor = "";
      this.asegurado = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.causa = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.atiende = "";
      this.fechaHoraAsignacion = "";
      this.depaOrigen = "";
      this.muniOrigen = "";
      this.comDireccionOrigen = "";
      this.depaDestino = "";
      this.muniDestino = "";
      this.comDireccionDestino = "";
      this.fechaHoraContacto = "";
      this.costoServicio = 0;
      this.fechaHoraCierreAsistencia = "";
      this.placaContraparte = "";
      this.partePolicial = false;
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.numeroSiniestroQualitas = "";
      this.numeroSpoolerQualitas = "";
      this.seMovioDelLugar = false;
      this.zonaPeligrosa = false;
      this.reporteTardio = false;
      this.roboRecuperado = false;
      this.operador = "";
      this.estatusAsistencia = "";
      this.errorPlaca = null;
      this.seguimiento1 = "";
      this.seguimiento2 = "";
      this.seguimiento3 = "";
      this.seguimiento4 = "";
      this.seguimiento5 = "";
      this.seguimiento6 = "";
      this.seguimiento7 = "";
      this.seguimiento8 = "";
      this.seguimiento9 = "";
      this.seguimiento10 = "";
      this.contador = 0;
      (this.numeroAsistenciaDialog = ""),
        (this.operadorDialog = ""),
        (this.fechaHoraActual = ""),
        (this.comDireccionSiniestroDialog = ""),
        (this.tipoServicioDialog = ""),
        (this.proveedorDialog = ""),
        (this.atiendeDialog = ""),
        (this.fechaHoraAsignacionDialog = ""),
        (this.fechaHoraContactoDialog = ""),
        (this.fechaHoraCierreAsistenciaDialog = ""),
        (this.obsAdicionalesDialog = "");
      this.recupero = false;
      this.cantRecupero = "";
      this.termino = "";
      this.estadoEbriedad = false;
    },
    verBitacora() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Bitacoras/MostrarCodigoSeguimiento/" + this.numeroAsistencia,
          configuracion
        )
        .then(function (response) {
          var arrayBitacora = [];
          arrayBitacora = response.data;
          me.editItem(arrayBitacora);
        })
        .catch(function (error) {
          console.log(error);
          me.errorPlaca = "No se encuentra registrada la placa.";
        });
    },
    //Metodo que separa la cadena de seguimiento por "~" y los muestra en cada campo de seguimientos.
    editItem(data = []) {
      this.cadena = "";
      this.separado = [];
      this.contador = 0;
      this.cadena = data["seguimiento"];
      this.separado = this.cadena.split("~");
      this.id = data["idBitacora"];
      this.numeroAsistenciaDialog = data["numeroAsistencia"];
      this.operadorDialog = data["operador"];
      this.fechaHoraActualDialog = data["fechaHoraActual"];
      this.comDireccionSiniestroDialog = data["comDireccionSiniestro"];
      this.tipoServicioDialog = data["tipoServicio"];
      this.proveedorDialog = data["proveedor"];
      this.atiendeDialog = data["atiende"];
      this.fechaHoraAsignacionDialog = data["fechaHoraAsignacion"];
      this.seguimiento1 = this.separado[0];
      this.seguimiento2 = this.separado[1];
      this.seguimiento3 = this.separado[2];
      this.seguimiento4 = this.separado[3];
      this.seguimiento5 = this.separado[4];
      this.seguimiento6 = this.separado[5];
      this.seguimiento7 = this.separado[6];
      this.seguimiento8 = this.separado[7];
      this.seguimiento9 = this.separado[8];
      this.seguimiento10 = this.separado[9];
      this.fechaHoraContactoDialog = data["fechaHoraContacto"];
      this.fechaHoraCierreAsistenciaDialog = data["fechaHoraCierreAsistencia"];
      this.obsAdicionalesDialog = data["obsAdicionales"];
      this.dialog = true;
      for (var i = 0; i < this.separado.length; i++) {
        this.contador++;
      }
      this.validDisabled();
    },
    //Metodo que deshabilita los campos que contienen comentarios.
    validDisabled() {
      if (this.seguimiento1) {
        this.disabled1 = true;
      } else {
        this.disabled1 = false;
      }
      if (this.seguimiento2) {
        this.disabled2 = true;
      } else {
        this.disabled2 = false;
      }
      if (this.seguimiento3) {
        this.disabled3 = true;
      } else {
        this.disabled3 = false;
      }
      if (this.seguimiento4) {
        this.disabled4 = true;
      } else {
        this.disabled4 = false;
      }
      if (this.seguimiento5) {
        this.disabled5 = true;
      } else {
        this.disabled5 = false;
      }
      if (this.seguimiento6) {
        this.disabled6 = true;
      } else {
        this.disabled6 = false;
      }
      if (this.seguimiento7) {
        this.disabled7 = true;
      } else {
        this.disabled7 = false;
      }
      if (this.seguimiento8) {
        this.disabled8 = true;
      } else {
        this.disabled8 = false;
      }
      if (this.seguimiento9) {
        this.disabled9 = true;
      } else {
        this.disabled9 = false;
      }
      if (this.seguimiento10) {
        this.disabled10 = true;
      } else {
        this.disabled10 = false;
      }
    },
    verificarRecupero() {
      if (this.cantRecupero != null) {
        //si es campo no esta vacio el checkbox se marcara y mostrara el campo
        this.recupero = true;
      }
    },
    descargarReincidencia() {
      let me = this;
      if (me.cabinas.length != 0) {
        let data = XLSX.utils.json_to_sheet(me.cabinas);
        const workbook = XLSX.utils.book_new();
        const filename = "Reincidencia";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      } else {
        me.$alertify.success("NO HAY DATOS QUE DESCARGAR");
      }
    },
  },
};
</script>
